// GET_LIMITED_CHECK_OUT
export const GET_CHECK_OUT_REQUEST = "GET_CHECK_OUT_REQUEST";
export const GET_CHECK_OUT_SUCCESS = "GET_CHECK_OUT_SUCCESS";
export const GET_CHECK_OUT_FAIL = "GET_CHECK_OUT_FAIL";
